<template>
  <div class="list-item income-li">
    <div class="item-left">
      <div class="item-text" :class="desc ? 'mb15' : 'mb30'">{{text}}</div>
      <span class="mb15 item-desc" v-if="desc">{{desc}}</span>
      <p class="item-grey">{{timeText}}时间：{{time}}</p>
    </div>
    <div class="item-text">{{money}}</div>
  </div>
</template>

<script>
export default {
  name: 'Item',
  props: {
    text: String,
    desc: String,
    time: String,
    money: [Number, String],
    timeText: {
      default: '打赏',
      type: String
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../index.scss';
.income-li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item-desc {
  font-family: PingFangSC-Regular;
  font-size: 26px;
  color: #7C8790;
  display: inline-block;
}
.mb15 {
  margin-bottom: 15px;
}
</style>
